import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendQueryVariationFeedbackReasonsArgs,
  BackendVariationReasons,
} from 'src/types/backend';

const QUERY = gql`
  query VariationFeedbackReasons($id: ID!, $rating: Int!) {
    variationFeedbackReasons(id: $id, rating: $rating) {
      reasons
    }
  }
`;

type Variables = BackendQueryVariationFeedbackReasonsArgs;
type Result = BackendVariationReasons;

export const queryVariationFeedbackReasons = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
